module.exports = __webpack_public_path__ + "media/images/wedding/19-f959523e88309ce696c9b1f71eb9eaf7.jpg";